<button type="button" class="btn btn-track" [disabled]="disabled" [ngClass]="{ tracked: idea.isTracked }" (click)="clicks.next($event)">
  <craft-icon class="svg-icon text-size-15 icon-track" name="search--mark" [matTooltip]="'common.text8' | craftTerm" matTooltipPosition="above"></craft-icon>
  <craft-icon
    class="svg-icon text-size-15 icon-untrack"
    name="idea-portal--Untrack"
    [matTooltip]="'common.text47' | craftTerm"
    matTooltipPosition="above"
  ></craft-icon>
</button>
